import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { Box, Typography } from '@mui/material'

interface LocationItemProps {
  name: string
  address: string
  timeSlot: string
  showConnector?: boolean
  isLast?: boolean
}

const containerStyles = {
  display: 'flex',
  alignItems: 'center', 
  gap: 2,
  mb: 2,
}

const iconContainerStyles = {
  position: 'relative' as const,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: '16px', 
}

const iconStyles = {
  fontSize: '16px',
  color: '#ccc',
  backgroundColor: '#fff',
}

const connectorStyles = {
  position: 'absolute' as const,
  top: '16px',
  width: '2px',
  height: '72px',
  borderLeft: '2px dashed #ccc',
  left: '50%',
  transform: 'translateX(-50%)',
}

const nameStyles = {
  fontSize: '16px',
  fontWeight: 600,
  color: '#333',
  mb: 0.5,
}

const addressStyles = {
  fontSize: '14px',
  color: '#666',
  mb: 0.5,
}

const timeSlotStyles = {
  fontSize: '14px',
  color: '#666',
}

export const LocationItem = ({
  name,
  address,
  timeSlot,
  showConnector = false,
  isLast = false,
}: LocationItemProps) => {
  return (
    <Box sx={containerStyles}>
      <Box sx={iconContainerStyles}>
        <RadioButtonUncheckedIcon sx={iconStyles} />
        {showConnector && !isLast && <Box sx={connectorStyles} />}
      </Box>
      <Box>
        <Typography variant='body1' sx={nameStyles}>
          {name}
        </Typography>
        <Typography variant='body2' sx={addressStyles}>
          {address}
        </Typography>
        <Typography variant='body2' sx={timeSlotStyles}>
          {timeSlot}
        </Typography>
      </Box>
    </Box>
  )
}
